'use client';
import { useState, useEffect } from 'react';

const WORDS = [
    { text: 'Living',      color: '#ef4444' },
    { text: 'Innovation',  color: '#3b82f6' },
    { text: 'Experiences', color: '#f97316' },
    { text: 'Connections', color: '#800000' },
    { text: 'Creators',    color: '#00d2be' },
];

export const TagLine = () => {
    const [index,   setIndex]   = useState(0);
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        const cycle = setInterval(() => {
            setVisible(false);
            setTimeout(() => {
                setIndex(i => (i + 1) % WORDS.length);
                setVisible(true);
            }, 400);
        }, 2600);
        return () => clearInterval(cycle);
    }, []);

    return (
        <div className="ennix-tagline text-center mt-4 mb-4">
            <style>{`
                @keyframes tl-slide-up {
                    0%   { opacity: 0; transform: translateY(18px) skewY(2deg); }
                    100% { opacity: 1; transform: translateY(0)    skewY(0deg); }
                }
                @keyframes tl-slide-down {
                    0%   { opacity: 1; transform: translateY(0)     skewY(0deg); }
                    100% { opacity: 0; transform: translateY(-18px) skewY(-2deg); }
                }
                .tl-word-enter {
                    display: inline-block;
                    animation: tl-slide-up 0.38s cubic-bezier(0.22,1,0.36,1) forwards;
                }
                .tl-word-exit {
                    display: inline-block;
                    animation: tl-slide-down 0.32s ease-in forwards;
                }
            `}</style>

            {/* ── Main heading ── */}
            <div className="m-0 tl-heading" style={{
                fontSize: 'clamp(1.8rem, 5vw, 2.8rem)',
                fontWeight: 800,
                lineHeight: 1.2,
                textAlign: 'center',
                whiteSpace: 'nowrap',
            }}>
                <span style={{ color: 'var(--primary-color)' }}>Powering Smart</span>
                {' '}
                {/* Slot locked to the width of the widest word */}
                <span style={{ position: 'relative', display: 'inline-block', verticalAlign: 'bottom' }}>
                    {/* Hidden spacer — reserves exact width of "Connections" */}
                    <span style={{ visibility: 'hidden', userSelect: 'none' }} aria-hidden="true">
                        Connections
                    </span>
                    {/* Animated word sits on top */}
                    <span style={{
                        position: 'absolute',
                        inset: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        overflow: 'hidden',
                    }}>
                        <span
                            key={WORDS[index].text}
                            className={visible ? 'tl-word-enter' : 'tl-word-exit'}
                            style={{ color: WORDS[index].color }}
                        >
                            {WORDS[index].text}
                        </span>
                    </span>
                </span>
            </div>

            {/* ── Sub brand line ── */}
            <p style={{ margin: '0.5rem 0 0', fontWeight: 600 }}>
                Ennix Electronics
            </p>

            {/* ── Subtitle ── */}
            <div>
                Premium tripods, microphones &amp; gimbals — designed for
                professional content creation.
            </div>
        </div>
    );
};
